import { Input, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ARIA_LABEL_SUFFIX } from '../../../../../staticComponents/StaticHtmlGenerator';

interface SharePointDatasetProps {
  setSiteUrl: (url: string) => void;
  setWorkflowUrl: (url: string) => void;
  setSharePointDatasetName: (name: string) => void;
}

export default function SharePointDataset({
  setSiteUrl,
  setWorkflowUrl,
  setSharePointDatasetName,
}: SharePointDatasetProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography fontSize={16} fontWeight={700} id="document-name-label">
        {t('fileUpload.enterDocumentName')} <span aria-hidden="true">*</span>
      </Typography>
      <Input
        fullWidth
        id="document-name-input"
        sx={{ padding: '0.2rem 0rem', marginBottom: '1rem' }}
        onChange={(e) => {
          setSharePointDatasetName(e.target.value);
        }}
        inputProps={{
          'aria-labelledby': 'document-name-label',
          'aria-required': 'true',
          'aria-label': `${t('fileUpload.enterDocumentName')} ${ARIA_LABEL_SUFFIX.REQUIRED}`,
        }}
      />
      <Typography fontSize={16} fontWeight={700} id="sharepoint-description-label" component="label" htmlFor="site-url">
        {t('fileUpload.enterSiteUrl')}
      </Typography>
      <Input
        fullWidth
        id="site-url"
        sx={{ padding: '0.2rem 0rem' }}
        onChange={(e) => {
          setSiteUrl(e.target.value);
        }}
        inputProps={{
          'aria-labelledby': 'sharepoint-description-label',
          'aria-label': `${t('fileUpload.enterSiteUrl')} ${ARIA_LABEL_SUFFIX.EDIT_OPTIONAL}`,
        }}
      />

      <Typography
        fontSize={16}
        fontWeight={700}
        sx={{ marginTop: '1rem' }}
        id="sharepoint-workflow-label"
        component="label"
        htmlFor="workflow-url"
      >
        {t('fileUpload.enterWorkflowURL')}
      </Typography>
      <Input
        fullWidth
        id="workflow-url"
        sx={{ padding: '0.2rem 0rem' }}
        onChange={(e) => {
          setWorkflowUrl(e.target.value);
        }}
        inputProps={{
          'aria-labelledby': 'sharepoint-workflow-label',
          'aria-label': `${t('fileUpload.enterWorkflowURL')} ${ARIA_LABEL_SUFFIX.EDIT_OPTIONAL}`,
        }}
      />
    </Box>
  );
}
